import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {
  detectPreferredLanguage,
  resolvePreferredLanguage,
} from "../../i18n/routing";
import { getLanguageMeta } from "../../i18n/languages";
import { LOCALE_STORAGE_KEY } from "../../i18n/localeConstants";

function persistAutoLanguage(language) {
  try {
    const meta = getLanguageMeta(language);
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    const prev = raw ? JSON.parse(raw) : {};
    if (prev.preferenceSource === "manual") return;
    localStorage.setItem(
      LOCALE_STORAGE_KEY,
      JSON.stringify({
        ...prev,
        language,
        currency: meta.currency,
        preferenceSource: "auto",
      })
    );
  } catch {
    // ignore
  }
}

export default function LocaleRedirect() {
  const [lang, setLang] = useState(() => detectPreferredLanguage());

  useEffect(() => {
    let cancelled = false;
    resolvePreferredLanguage().then((next) => {
      if (cancelled) return;
      persistAutoLanguage(next);
      setLang(next);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return <Navigate to={`/${lang}`} replace />;
}
